import { IComponentOptions } from "angular";
import { ProgressivesDetailComponentController } from "./controller";

export const vsName = "progressiveDetail";

export const progressivesDetailComponentOptions: IComponentOptions = {
  controller: ProgressivesDetailComponentController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    progressiveDefinition: "<",
  },
};
